import React from 'react';
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled(Grid)(({ theme }) => ({
  position: 'absolute',
  right: '.2em',
  top: '4%',
  [theme.breakpoints.up('sm')]: {
    top: '20%',
  },
}));

type CollapsableCardHeaderActionsContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used as a container for additional actions in the header of the Collapsable Card suite of components
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardHeaderActionsContainer = ({ children, ...rest}: CollapsableCardHeaderActionsContainerProps) => {
  return <Root item alignItems={'center'} justifyContent={'center'} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardHeaderActionsContainer };
